import styled from 'styled-components';

const StyledCloseButton = styled.button`
  display: inline-flex;
`;

export { StyledCloseButton };
